export default "__VITE_ASSET__DQOaJo3x__"